module.exports = __webpack_public_path__ + "static/media/screenshot(36).a92a8239.jpg";